
export enum NetExplosiveMassUomCd {
	GRAMS = 'Grams',
	KILOGRAMS = 'Kilograms',
	MILLIGRAMS = 'Milligrams',
	OUNCES = 'Ounces',
	POUNDS = 'Pounds'}

